export default "__VITE_ASSET__B0Byzauh__"